import CarouselComponent from '../components/Carousel';
import { Box, Typography, Container, Stack, Link } from '@mui/material';
import Buttons from '../components/Buttons';
import DividerImage from '../components/Divider';

function Home() {
    const features = [
        "Używam nowego, jednego z najlepiszych i licencjonowanego sprzętu",
        "Oferuję w pełni profesjonalne i indywidualne podejście do pacjenta",
        "Posiadam certyfikaty potwierdzające moje umiejętności",
        "Posiadam wieloletnie doświadczenie z zakresie masażu i fizjoterapii",
    ];

    return (
        <Box>
            <CarouselComponent />

            <Box sx={{ padding: 2 }}>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: "'Arizonia', cursive",
                        fontWeight: 400,
                        letterSpacing: '.1rem',
                        color: 'inherit',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        justifyContent: 'center',
                    }}
                >
                    Relaks & Komfort
                </Typography>
                <Typography variant="h4">Witaj w moim gabinecie masażu</Typography>

                <DividerImage />

                <Buttons />

                <Container sx={{ py: 10 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 4,
                            alignItems: 'center',
                        }}
                    >
                        <Box sx={{ flex: { xs: '1 1 100%', md: '0 0 50%' }, display: 'flex', justifyContent: 'center' }}>
                            <Box
                                component="img"
                                src="/4.jpg"
                                alt="Obraz masaż"
                                sx={{
                                    width: { xs: '100%', md: '80%' },
                                    height: 'auto',
                                    borderRadius: 4,
                                    minHeight: 300,
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: { xs: '1 1 100%', md: '0 0 50%' } }}>
                            <Typography
                                variant="h5"
                                gutterBottom
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: "'Arizonia', cursive",
                                    fontWeight: 400,
                                    letterSpacing: '.1rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                }}
                            >
                                Piękno & Zdrowie
                            </Typography>
                            <Typography variant="h4">Dlaczego warto?</Typography>

                            <DividerImage />

                            <Stack spacing={2} mt={2}>
                                {features.map((text, index) => (
                                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Box
                                            component="img"
                                            src="/check.jpg"
                                            alt="Ikona check"
                                            sx={{ width: 30, height: 30 }}
                                        />
                                        <Typography variant="body1" sx={{ textAlign: "start" }}>{text}</Typography>
                                    </Box>
                                ))}
                            </Stack>
                        </Box>
                    </Box>
                </Container>

                <Container sx={{ py: 6 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 4,
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                flex: { xs: '1 1 100%', md: '0 0 50%' },
                                display: 'flex',
                                justifyContent: 'center',
                                order: { xs: 1, md: 2 },
                            }}
                        >
                            <Box
                                component="img"
                                src="/voucher.jpg"
                                alt="Voucher"
                                sx={{
                                    width: { xs: '100%', md: '80%' },
                                    height: 'auto',
                                    borderRadius: 4,
                                    minHeight: 300,
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                flex: { xs: '1 1 100%', md: '0 0 50%' },
                                order: { xs: 2, md: 1 },
                            }}
                        >
                            <Typography
                                variant="h5"
                                gutterBottom
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: "'Arizonia', cursive",
                                    fontWeight: 400,
                                    letterSpacing: '.1rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                }}
                            >
                                Relaks & Komfort
                            </Typography>
                            <Typography variant="h4">Istnieje możliwość wykupienia bonu podarunkowego</Typography>

                            <DividerImage />

                            <Typography variant="body1" mt={2}>
                                Bon może zostać wykupiony na konkretne zabiegi lub też kwotę pieniężną do wykorzystania w salonie
                            </Typography>
                            <Typography variant="body1" mt={2}>
                                Może być on wysłany na maila lub odebrany bezpośrednio w salonie
                            </Typography>
                        </Box>
                    </Box>
                </Container>

                <Container sx={{ py: 6 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 4,
                            alignItems: 'center',
                        }}
                    >
                        <Box sx={{ flex: { xs: '1 1 100%', md: '0 0 50%' }, display: 'flex', justifyContent: 'center' }}>
                            <Box
                                component="img"
                                src="/calendar.jpg"
                                alt="Calendar"
                                sx={{
                                    width: { xs: '100%', md: '80%' },
                                    height: 'auto',
                                    borderRadius: 4,
                                    minHeight: 300,
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: { xs: '1 1 100%', md: '0 0 50%' } }}>
                            <Typography
                                variant="h5"
                                gutterBottom
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: "'Arizonia', cursive",
                                    fontWeight: 400,
                                    letterSpacing: '.1rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                }}
                            >
                                Piękno & Zdrowie
                            </Typography>
                            <Typography variant="h4">Umów się na wizytę</Typography>

                            <DividerImage />

                            <Typography variant="h5" mt={2}>
                                Masz pytania lub chcesz ustalić termin?
                            </Typography>
                            <Typography variant="body1" mt={2}>
                                Zadzwoń: <Link
                                    href="tel:+48512208653"
                                    underline="hover"
                                    color="inherit"
                                    sx={{ cursor: "pointer" }}
                                >
                                    +48 512 208 653
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
}

export default Home;
